import TableHeaderHtmlCustom from '../../../../components/common/customTable/TableHeaderHtmlCustom';
import { TableCompHead } from '../../../../components/ui';
import { useQuery } from '../../../../hooks/UseQuery';
import { moduleConstant } from '../constant';

const style1 = {
  backgroundColor: '#4F81BD',
  color: '#fff',
  minWidth: '100px',
  height: '50px',
};
const style2 = {
  backgroundColor: '#00B050',
  color: '#fff',
  minWidth: '80px',
};

interface IProps {
  isView: boolean;
}

const THead = ({ isView }: IProps) => {
  const date = useQuery('date');
  const year = date && new Date(date).getFullYear();
  const tableHeaderObj = [
    [
      { text: 'S.No.'.toUpperCase(), style: style1, rowspan: 1 },
      { text: 'Date'.toUpperCase(), style: style1, rowspan: 1 },
      { text: 'Machine No.'.toUpperCase(), style: style1, rowspan: 1 },
      { text: 'Location'.toUpperCase(), style: style1, rowspan: 1 },
      { text: 'BREAK DOWN HRS (In Min.)'.toUpperCase(), style: style1, rowspan: 1 },
      { text: 'CUMM. BREAK DOWN HRS (In Min.)'.toUpperCase(), style: style1, rowspan: 1 },
      { text: '% CUMM. BREAK DOWN HRS/MINS (In Min.)'.toUpperCase(), style: style1, rowspan: 1 },
      { text: 'PROBLEM DETAILS'.toUpperCase(), style: style1, rowspan: 1 },
      // { text: 'Reason'.toUpperCase(), style: style1, rowspan: 1 },
      // { text: 'Action Plan'.toUpperCase(), style: style1, rowspan: 1 },
      // { text: 'PARTS USED'.toUpperCase(), style: style1, rowspan: 1 },
      // { text: 'Cost'.toUpperCase(), style: style1, rowspan: 1 },
      // { text: 'Attended By'.toUpperCase(), style: style1, rowspan: 1 },
      // { text: 'Remarks'.toUpperCase(), style: style1, rowspan: 1 },
      // {
      //   text: 'Analysis Of Down Time'.toUpperCase(),
      //   style: style1,
      //   rowspan: 1,
      // },
      { text: 'Action'.toUpperCase(), style: style1, rowspan: 1 },
    ],
  ];
  return (
    <thead
      style={{
        position: 'sticky',
        width: '100%',
        top: '-.5rem',
        border: '1px solid black',
        zIndex: '1',
        backgroundColor: '#38d9a9',
        color: 'black',
      }}
    >
      <TableCompHead
        colSpan={9}
        rowSpan={3}
        labels={['F.NO.:', 'REV. NO.', 'Date']}
        values={['HO-F-MNT-11', '00', '01.09.2103']}
        heading={`${moduleConstant?.heading} - ${year}`}
      />
      <TableHeaderHtmlCustom tableHeaderObj={tableHeaderObj} />
    </thead>
  );
};

export default THead;
